import { render, staticRenderFns } from "./ModelDetailDrawer.vue?vue&type=template&id=37769134&scoped=true"
import script from "./ModelDetailDrawer.vue?vue&type=script&lang=js"
export * from "./ModelDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./ModelDetailDrawer.vue?vue&type=style&index=0&id=37769134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37769134",
  null
  
)

export default component.exports